<template>

  <div>
    <router-view/>
  </div>

</template>

<script>
  export default {
    name: 'AdminAccounts',
  }
</script>

<style scoped>
</style>
